import { Reflector } from '../reflection';
export function effect(deps) {
  return function (target, propertyKey) {
    Reflector.setInEffectKeysMap(target, propertyKey, deps);
  };
}
export function onDidMount() {
  return effect(function () {
    return [];
  });
}
export function onDidRender() {
  return effect();
}